/**
 * Route selectors for SCI
 */

export const getCurrentLocation = (_state: any): string => '/trade-in';

export const isUserRedirectedToManualEntry = (_state: any): boolean => false;

export const isDDPPage = (_state: any): boolean => false;

export const isDealerShowroomExperience = (_state: any): boolean => false;
